import { render, staticRenderFns } from "./RenderChart.vue?vue&type=template&id=3bdd01fa&scoped=true"
import script from "./RenderChart.vue?vue&type=script&lang=js"
export * from "./RenderChart.vue?vue&type=script&lang=js"
import style0 from "./RenderChart.vue?vue&type=style&index=0&id=3bdd01fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd01fa",
  null
  
)

export default component.exports